import { Group } from "@lab/types/groups";
import { HealthService } from "@lab/types/healthservice";
import { healthservice as api } from "../../api/health.service.api";
const state = {
	healthservice: null,
	groups: [],
	isFetching: false,
	errorMessage: null,
	lastFetched: null // Timestamp
};

const getters = {
	get: (state) => state.healthservice as HealthService,
	groups: (state, getters) => {
		return state.groups.map((group) => {
			const hospital = getters.hospitals.find(
				(h) => h.id === group.hospitalid
			);
			return {
				id: group.id,
				hospital: {
					id: hospital ? hospital.id : 0,
					name: hospital ? hospital.name : ""
				},
				name: group.name
			};
		}) as Group[];
	},
	hospitals: (_) => state.healthservice.hospitals || []
};

const actions = {
	async fetch({ dispatch }, id) {
		const healthservice = await api.get(id);
		dispatch("set", healthservice);
	},
	async set({ commit }, healthservice) {
		commit("SET_HEALTHSERVICE", healthservice);

		let groups = [];

		if (healthservice) {
			groups = await api.groups.get(healthservice.id);
		}

		commit("SET_GROUPS", groups);
	},
	create() {},
	update() {},
	remove() {}
};

const mutations = {
	LOAD_FINISH(state: any) {
		state.errorMessage = null;
		state.isFetching = false;
	},
	LOAD_START(state: any) {
		state.errorMessage = null;
		state.isFetching = true;
	},
	SET_GROUPS(state: any, groups: Group[]) {
		state.groups = groups;
	},
	SET_HEALTHSERVICE(state: any, healthservice: HealthService) {
		state.healthservice = healthservice;
	}
};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
};
